import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general-info'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'general_info_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'owner'],
          },
        },
      ],
    },
  ],
};
